import * as d3 from "d3";

export const randomNodeId = (length?: number): string => {
  if (length == null) {
    length = 5;
  }

  return Math.random().toString(36).substr(2, length);
};

export const scrollPosition = () => {
  const doc = document.documentElement;
  return {
    left: (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0),
    top: (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0),
  };
};

export const nodeAbsoluteBounds = (node: Element) => {
  const bb = node.getBoundingClientRect();
  const scroll = scrollPosition();
  return {
    left: bb.left + scroll.left,
    top: bb.top + scroll.top,
    width: bb.width,
    height: bb.height,
  };
};

export const nodeRelativeBounds = (node: Element, relativeToNode: Element) => {
  const nb = nodeAbsoluteBounds(node);
  const rb = nodeAbsoluteBounds(relativeToNode);
  return {
    left: nb.left - rb.left,
    top: nb.top - rb.top,
    width: nb.width,
    height: nb.height,
  };
};

export const shorten = (str: string, maxlen: number): string => {
  if (str.length > maxlen) {
    return str.substr(0, maxlen) + "…";
  } else {
    return str;
  }
};

export const findIndex = <T>(arr: T[], predicate: (x: T) => boolean): undefined | number => {
  let a, i, j, len;
  for (i = j = 0, len = arr.length; j < len; i = ++j) {
    a = arr[i];
    if (predicate(a)) {
      return i;
    }
  }
  return void 0;
};

export const anchorPosition = (node: Element, pos: [number, number], anchor: string, opts: any): void => {
  let left = "0px",
    top = "0px";
  const tooltip = d3.select(node);
  switch (anchor) {
    case "north":
      left = px(pos[0] - node.clientWidth / 2);
      top = px(pos[1] - node.clientHeight - ((opts && opts.ygap) || 0));
      break;
    case "south":
      left = px(pos[0] - node.clientWidth / 2);
      top = px(pos[1] + ((opts && opts.ygap) || 0));
  }
  tooltip.style("left", left);
  tooltip.style("top", top);
};

export const px = (val: number): string => {
  return Math.round(val) + "px";
};
